<template>
<div>

  <v-row>
    <v-col lg="4" md="3" cols="12" class="text-center align-self-center">
      <v-divider style="border-width:1px;border-color:#2e368f"></v-divider>
    </v-col>

    <v-col lg="4" md="6" cols="12" class="text-center align-self-center">
      <h2 id="title" class="display-2  flex-grow-1" style="font-family:'Tajawal', sans-serif !important">{{title}}</h2>
    </v-col>

    <v-col lg="4" md="3" cols="12" class="text-center align-self-center">
      <v-divider style="border-width:1px;border-color:#2e368f"></v-divider>
    </v-col>

  </v-row>
    <carousel
      dir="ltr"
      :margin="8"
      :nav="false"
      :responsive="{0:{items:2 },575:{items:2},768:{items:3},1100:{items:4},1250:{items:5 }}"
      class="mt-4 "
    >
       <!-- :perPageCustom="[[0,1],[575, 2],[1100, 4],[1250, 5]]" -->
       <!-- <div><h4>424</h4></div> -->
        <product-card v-for="(product , idx) in items"   class="my-3" :key="idx" :product="product"></product-card>
     </carousel>
</div>
</template>

<script>
import ProductCard from "@/components/single-product/ProductCard.vue";
import carousel from 'vue-owl-carousel'
export default {
  props: {
    title: String,
    items: Array
  },
  components: { ProductCard, carousel,   },
  data: () => ({
    products: [
      {
        img:
          "https://www.worldofwatches.com/media/catalog/product/cache/9df2eec62a290f757942cbd6dcc3d91d/b/o/bottega-veneta-redwhite-tote-570800-vmaa0-8749.jpg"
      },
      {
        img:
          "https://www.worldofwatches.com/media/catalog/product/cache/9df2eec62a290f757942cbd6dcc3d91d/b/u/burberry-large-navy-crest-logo-cashmere-scarf-4075222.jpg"
      },
      {
        img:
          "https://www.worldofwatches.com/media/catalog/product/cache/9df2eec62a290f757942cbd6dcc3d91d/m/e/mens-prs-516-stainless-steel-black-dial-t1004301105100.jpg"
      },

      {
        img:
          "https://www.worldofwatches.com/media/catalog/product/cache/9df2eec62a290f757942cbd6dcc3d91d/a/c/acqua-di-parma-colonia-pura-eau-de-cologne-cos8028713270017_1.jpg"
      },
      {
        img:
          "https://www.worldofwatches.com/media/wysiwyg/homepageicons-beauty.jpg"
      }
    ],
    loading: false,
    selection: 1
  })
};
</script>

<style >
.display-2 {
  font-size: 2.7rem !important;
  text-transform: uppercase;
  padding-bottom: 10px;
}

/* .owl-stage{
  margin: auto !important;
} */
@media (min-width: 1264px) {
  .lg5-custom {
    width: 15% !important;
    max-width: 15% !important;
    flex-basis: 15% !important;
  }
}
</style>
